module.exports = __webpack_public_path__ + "img/Default-J-16.264564e2.svg";